export const PIWIK_SITE_ID = '1';
export const PIWIK_URL = 'https://telemetry.seeq.com/piwik/piwik.php';

export const TRACK = {
  ACCESS_CONTROL: 'Access Control',
  ACCESS_CONTROL_GLOBAL_CONFIRMATION: 'Access Control Global Confirmation',
  ACL_MODAL: 'ACL Modal',
  ADMINISTRATION: 'Administration',
  AGENT_BUILDER: 'Agent Builder',
  AI_ASSISTANT: 'AiAssistant',
  AI_FEEDBACK: 'AiFeedback',
  ALL_CAPSULES: 'All Capsules',
  ANALYSIS: 'Analysis',
  APPLICATIONS: 'Applications',
  APPROVAL_FLOW: 'Approval Flow',
  ASSET_GROUP: 'Asset Group',
  ASSET_GROUP_EDITOR: 'Asset Group Editor',
  AUDIT_TRAIL: 'Audit Trail',
  CAPSULE_GROUP: 'Capsule Group',
  CAPTURES: 'Captures',
  CHANGE_VIEW: 'change view',
  CK_EDITOR: 'CKEditor',
  CLUSTER: 'Cluster',
  DATE_RANGE_ASSET_SWAP: 'DateRange Asset Swap',
  DATE_SELECTED: 'Date selected',
  DATE_TIME_PICKER: 'DateTimePicker',
  DISPLAYS: 'Displays',
  ENTERPRISE_LICENSING: 'Enterprise Licensing',
  ERROR: 'ERROR',
  EXPORT: 'Export',
  FILTER_TABLE: 'FILTER.TABLE',
  HELP_CENTER: 'Help Center',
  HOME_SCREEN: 'Home Screen',
  HOMESCREEN_2_0: 'HomeScreen 2.0',
  HOMESCREEN_ADD_ON: 'Homescreen Add-On',
  IMPACT_REPORT: 'Impact Report',
  INSIGHT: 'Insight',
  INVESTIGATE_RANGE_SELECTOR: 'InvestigateRangeSelector',
  ISOLATION_FOREST: 'Isolation Forest',
  ITEM: 'Item',
  ITEM_PROPERTIES: 'Item Properties',
  JOURNAL: 'Journal',
  LOCKING_VERSIONING: 'Locking/Versioning',
  MENU: 'Menu',
  MULTI_SELECT: 'Multi-Select',
  NOTIFICATION: 'Notification',
  ORGANIZER_TEMPLATE: 'Organizer Template',
  PARTIAL_LEAST_SQUARES: 'Partial Least Squares',
  POPULAR_WORK: 'Popular Work',
  PREDICTION: 'Prediction',
  PRINCIPAL_COMPONENT_ANALYSIS: 'Principal Component Analysis',
  PROJECT: 'Project',
  RANGE_SELECTOR: 'RangeSelector',
  REFERENCE_PROFILE: 'Reference Profile',
  REQUEST_DETAILS: 'Request Details',
  SANDBOX_MODE: 'Sandbox Mode',
  SCALING_TABLE_COLUMN_CONFIGURATION: 'Scaling Table Column Configuration',
  SCALING_TABLE_CONFIGURATION: 'Scaling Table Configuration',
  SCATTERPLOT: 'Scatterplot',
  SEARCH: 'Search',
  SEARCH_RESULTS: 'Search results',
  SELECTED_CAPSULES: 'Selected Capsules',
  SELF_ORGANIZING_MAP: 'Self Organizing Map',
  SKILLS_BUILDER: 'Skills Builder',
  STATISTICS_SUMMARY: 'Statistics Summary',
  STORED_TABLE_CONFIGURATION: 'Stored Table Configuration',
  SUMMARY_REPORT: 'Summary Report',
  SYSTEM: 'System',
  TABLE_BUILDER: 'Table Builder',
  TEMPLATE: 'Template',
  TOPIC: 'Topic',
  TRAINING: 'Training',
  TREE_BUILDER: 'Tree Builder',
  TREE_BUILDER_OVERVIEW: 'Tree Builder Overview',
  TREEMAP: 'Treemap',
  TREND: 'Trend',
  UPDATE_EXPORT: 'Update Export',
  USAGE: 'Usage',
  USER_ADMINISTRATION: 'User Administration',
  VANTAGE: 'Vantage',
  WARNING: 'Warning',
  WORKBENCH: 'Workbench',
  WORKBENCH_2_0: 'Workbench_2.0',
  WORKBENCH_TOOL: 'Workbench_Tool',
  WORKSHEETS: 'Worksheets',
  WORKSTEPS: 'Worksteps',
  XY_PLOT: 'XY Plot',
} as const;

export type TrackCategory = (typeof TRACK)[keyof typeof TRACK];
